var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_295)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.09,
    height: 20,
    rx: 9.545,
    fill: "#D80909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59027 5.00001C5.43485 4.99914 5.28466 5.05938 5.17376 5.16941C5.06287 5.27943 5 5.42962 5 5.58592C5 5.74309 5.06287 5.8924 5.17376 6.0033L8.94231 9.77185L5.17376 13.5413C4.94587 13.7709 4.94587 14.1403 5.17376 14.3699C5.4034 14.5987 5.77364 14.5987 6.00327 14.3699L9.77272 10.6014L13.5413 14.3699C13.6522 14.4808 13.8015 14.5437 13.9578 14.5437C14.1141 14.5437 14.2643 14.4808 14.3743 14.3699C14.6031 14.1403 14.6031 13.7701 14.3743 13.5404L10.6048 9.77098L14.3743 6.00242C14.4861 5.89153 14.5481 5.74308 14.5481 5.58592C14.5481 5.42962 14.4861 5.27943 14.3743 5.16941C14.2634 5.05938 14.1132 4.99914 13.9578 5.00001C13.8015 4.99914 13.6513 5.05938 13.5404 5.16941L9.77185 8.93885L6.0024 5.16941C5.89238 5.06113 5.74484 5.00001 5.59027 5.00001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.09,
    height: 20,
    rx: 9.545,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9f8eb509de3e78fb31296318bd8576dd.svg";
export { ForwardRef as ReactComponent };